import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findUnallocatedStudent({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`student/distribution/findUnallocatedStudent`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findAllocatedStudent({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`student/distribution/findAllocatedStudent`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  save({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`student/distribution/save`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findUserByProvinceId({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`user/findUserByProvinceId`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getUserResponsibleProvince({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`user/getUserResponsibleProvince`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


}
